import { Preset } from '../models/preset';

export const DEFAULT_PRESETS: Array<Preset> = [
  {
    prompt: "What's for dinner?",
    options: ['Korean BBQ', 'Yakitori'],
  },
];
